const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'org_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_ORGS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_ORGS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_ORGS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_ORG':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.org_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orgs.js